import {getJsonScriptContent} from '../utils/dom/getJsonScriptContent';

const defaultLocalizationOptions = {
    decimalPoint: '.',
    groupingSeparator: ',',
    locale: 'en_US',
    timeZone: 'UTC',
};

const element = document.getElementById('localization-options');

export const localizationOptions = getJsonScriptContent(element, defaultLocalizationOptions);
